import { Component, OnDestroy, OnInit } from '@angular/core';
import { AnalyticEvent, AnalyticsBloc, AnalyticsPageName } from '@kanalytics';
import { EligibilityCandidate } from '@kp/eligibility/eligibility-candidate.model';
import { OnboardingBloc } from '@kp/onboarding/onboarding.bloc';
import { WorkbookBloc } from '@kp/workbook/workbook.bloc';
import { DateTimeUtil } from '@kutil';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'kp-screen-workbook-confirmed',
  templateUrl: './screen-workbook-confirmed.component.html',
  styleUrls: ['./screen-workbook-confirmed.component.scss'],
})
export class ScreenWorkbookConfirmedComponent implements OnInit, OnDestroy {
  constructor(
    private _analyticsBloc: AnalyticsBloc,
    private _deviceDetectorService: DeviceDetectorService,
    private _onboardingBloc: OnboardingBloc,
    public workbookBloc: WorkbookBloc
  ) {}

  candidate: EligibilityCandidate;
  continueLink = this._deviceDetectorService.isDesktop()
    ? '/welcome/mobile-app/interstitial'
    : '/welcome/mobile-app/interstitial/mobile';
  date: string;

  private _destroy$ = new Subject<void>();

  ngOnInit() {
    this._analyticsBloc.sendEvent(
      this._analyticsBloc.createEventFromInteraction({
        page: AnalyticsPageName.workbook,
        event: AnalyticEvent.workbook_confirmation_shown,
      })
    );
    this._onboardingBloc.eligibilityCandidateStatus$.pipe(takeUntil(this._destroy$)).subscribe((candidateStatus) => {
      if (candidateStatus?.data) {
        this.candidate = candidateStatus.data;
        this.candidate.clearPersonalInfo();
        this._onboardingBloc.setEligibilityCandidateData(this.candidate);
      }
      if (!candidateStatus) {
        this._onboardingBloc.updateEligibilityCandidateFromStorage();
      }
    });
    this.date = DateTimeUtil.formatDate(new Date(), 'MMMM d, y');
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
